<template>
	<div class="link-tree">
		<link-scroll fit-host-width :scrollbarSize="6" ref="scroll">
			<div class="link-tree-content">
				<link-tree-node v-for="(item,index) in data"
								ref="children"
								:key="index"
								v-bind="passProps"
								:data="item"
								:level="1"
								:index="index+1">
					<template slot-scope="{data:nodeData,level,index:nodeIndex,parentIndex}">
						<slot :data="nodeData" :level="level" :index="nodeIndex">
							{{nodeData[labelKey]}}
						</slot>
					</template>
				</link-tree-node>
			</div>
		</link-scroll>
	</div>
</template>

<script>
	import LinkTreeNode from "./link-tree-node";
	import {TREE_PUB} from "./index";

	export default {
		name: "link-tree",
		components: {LinkTreeNode},
		provide() {
			return {
				linkTree: this,
			}
		},
		props: {
			...TREE_PUB.pubProps,
		},
		computed: {
			passProps() {
				return Object.keys(TREE_PUB.pubProps).reduce((ret, key) => {
					ret[key] = this[key]
					return ret
				}, {})
			},
		},
		methods: {
			/**
			 * 展开某一个节点，连同其父节点
			 * @author  韦胜健
			 * @date    2019/9/25 17:00
			 */
			expand(compareFunc, cascade = true) {
				let node = this.getNode(compareFunc)
				if (!cascade) {
					node.expanded = true
				} else {
					do {
						node.expanded = true
						node = node.parent
					} while (!!node)
				}
			},
			/**
			 * 展开某一个节点，并且滚动到该节点
			 * @author  韦胜健
			 * @date    2019/9/25 17:02
			 */
			async scrollTo(compareFunc) {
				const treeNode = this.getTreeNode(compareFunc)
				if (!treeNode) return
				let node = treeNode.node
				do {
					node.expanded = true
					node = node.parent
				} while (!!node)
				await this.$lv.$utils.delay(200)
				this.$refs.scroll.scrollTop(treeNode.$el.offsetTop - 100)
			},

			/**
			 * 获取treeNode实例对象
			 * @author  韦胜健
			 * @date    2019/9/25 17:01
			 */
			getTreeNode(compareFunc) {
				let treeNode;
				this.iterateChildren(this.$refs.children, (child) => {
					const flag = compareFunc(child)
					if (flag) treeNode = child
					return flag
				})
				return treeNode
			},
			/**
			 * 获取treeNode实例对象的node数据
			 * @author  韦胜健
			 * @date    2019/9/25 17:01
			 */
			getNode(compareFunc) {
				const treeNode = this.getTreeNode(compareFunc)
				return treeNode.node
			},
			/**
			 * 遍历子节点辅助函数
			 * @author  韦胜健
			 * @date    2019/9/25 17:02
			 */
			iterateChildren(children, func) {
				if (!!children && children.length > 0) {
					for (let i = 0; i < children.length; i++) {
						const child = children[i];
						const flag = func(child)
						if (flag) {
							return
						} else {
							this.iterateChildren(child.$refs.children, func)
						}
					}
				}
			},
		}
	}
</script>

<style lang="scss">
	.link-tree {
		height: 100%;
		width: 100%;

		.link-tree-content {
			padding: 12px 0;
		}
	}
</style>
